import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTcfGvlPut = {
    path: "/tcf/gvl",
    method: RouteHttpVerb.PUT
};
export { locationRestTcfGvlPut };
